import { AxiosMethod, defaultAxiosOptions } from '../../constants';
import serviceEndpointsV2 from '../../constants/api_v2';
import { DataFiltersModel, StatisticModel } from '../../models';
import { AxiosPromise, AxiosRequestConfig } from 'axios';
import useAxios from 'axios-hooks';
import { ResponseValuesOverride } from '../../models/response-values-override';

export function useFetchOfferSummaryStatistic(): [
  ResponseValuesOverride<StatisticModel>,
  (params: DataFiltersModel) => AxiosPromise<StatisticModel>,
] {
  const config: AxiosRequestConfig = {
    method: AxiosMethod.Get,
    url: serviceEndpointsV2.offerSummaryStatistic(), //serviceEndpoints.statistic(),
  };

  const [data, execute] = useAxios<StatisticModel>(
    {},
    { ...defaultAxiosOptions },
  );

  return [
    data,
    (params: DataFiltersModel) =>
      execute({
        ...config,
        params,
      }),
  ];
}
